import { Zap } from "lucide-react";

const ITEMS = [
  "Complex Electrical Diagnostics",
  "Brake Repair & Axle Service",
  "Computerized Engine Scanning",
  "Pre-Purchase Inspections",
  "Battery & Alternator Testing",
  "GTA-Wide Driveway Service",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-white/10 bg-charcoal py-5 overflow-hidden select-none"
    >
      <div className="flex w-max animate-gogo-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center gap-6 pr-6 font-display font-bold uppercase tracking-[0.2em] text-xl sm:text-2xl text-white/25 whitespace-nowrap"
              >
                {item}
                <Zap className="w-4 h-4 text-ember shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
